import React, { useEffect } from 'react';
import { Box, Card, CardContent, Grid, Typography, Button, Stack, Divider } from '@mui/material';
import apiService from '../../services/apiServices';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function CompanyProfile() {
  const { t } = useTranslation();
  const { setValue, watch } = useForm();

  useEffect(() => {
    apiService().get('settings').then((res) => {
      if (res?.success && res.data?.length) {
        const s = res.data[0];
        Object.keys(s).forEach((k) => setValue(k, s[k]));
      }
    });
  }, [setValue]);

  const brand = watch('BrandColor') || '#2563eb';

  const onPrint = () => {
    window.print();
  };

  return (
    <Box>
      <Card>
        <CardContent>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>{t('report.companyProfile')}</Typography>
            <Button variant="outlined" onClick={onPrint}>{t('report.print')}</Button>
          </Stack>
          <Divider sx={{ mb: 2, borderColor: brand }} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <img alt="logo" src={watch('Logo')} style={{ maxWidth: 160, border: `2px solid ${brand}`, borderRadius: 8, padding: 8 }} />
            </Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="h5" sx={{ fontWeight: 700, color: brand }}>{watch('CompanyName')}</Typography>
              <Typography variant="body2">NUI: {watch('NUI')}</Typography>
              <Typography variant="body2">Email: {watch('Email')}</Typography>
              <Typography variant="body2">Tel: {watch('Phone')}</Typography>
              <Typography variant="body2">{t('report.address')}: {watch('Address')}, {watch('City')}</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

